import React, { useState, useEffect, Fragment } from 'react';
import {
  Row,
  Input,
  FormGroup,
  CustomInput,
  Button,
  ButtonGroup,
  Form,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
} from 'reactstrap';
import {
  Colxx,
  Separator,
} from '../../../../../components/common/CustomBootstrap';
import {
  dAPI_Delete_Ingetration,
  gAPI_Property_List,
} from '../../../../../constants/APIs';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import stripe_logo from '../../../../../assets/stripe_logo.jpg';
export default function StripeIntregation({
  toggle,label,
  paymentmodelvisible,
  LoadIntegrations,
  handlePayment,
  handleProerptyId,
  allProperties,
  integration,
  refreshConnection,
}) {
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [selectedproperty, setselectedproperty] = useState('');
  const [selectedpropertyfordelete, setselectedpropertyfordelete] =
    useState('');
  const [inputData, setInputData] = useState({
    Properties: '',
  });

  const handleCheckChange = (e) => {
    let val = 0;
    integration.map((m) => {
      //console.log(m.properties[0], e);
      if (m.properties[0] === e) {
        val = 1;
        toggleDelete();
      }
    });
    if (val === 0) {
      handleProerptyId(e);
      //console.log(val);
      setselectedproperty(e);
      setInputData({ ...inputData, Properties: e });
    } else {
      setselectedpropertyfordelete(e);
      setInputData({ ...inputData, Properties: '' });
    }
  };
  const checkConnct = async () => {
    integration.map((m) => {
      if (m.properties[0] === selectedpropertyfordelete) {
        handleDelete(m.id, m.channelDetails.stripeCustomerId);
        toggleDelete();
      }
    });
    //console.log(integration, selectedpropertyfordelete);
  };
  const toggleDelete = () => {
    setDeleteVisible(!deleteVisible);
  };
  const handleDelete = async (id, customerid) => {
    await AxiosAPI({
      method: 'delete',
      url: `${dAPI_Delete_Ingetration}/${id}/?group_id=${getGroupID()}`,
    }).then((res) => {
      toggle();
      refreshConnection('Archieve', customerid);
      LoadIntegrations();
    });
  };
  const handleNameChange = (e) => {
    e.persist();
    setInputData({ ...inputData, Name: e.target.value });
  };

  const generateDeleteButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="8" className="mb-4">
          <Row>
            <Colxx xs="12" sm="5" className="mb-1">
              <Modal isOpen={deleteVisible} toggle={toggleDelete}>
                <ModalHeader toggle={toggleDelete}>
                  <span role="img" aria-label="warning">
                    ⚠️
                  </span>
                  You have already stripe connection so for new connection
                  please disconnected all previous connection for this property
                </ModalHeader>
                <ModalBody>
                  <Button
                    color="danger"
                    onClick={() => checkConnct()}
                    size="xs"
                  >
                    Delete
                  </Button>
                  <Button
                    className="ml-2"
                    color="dark"
                    outline
                    size="xs"
                    onClick={toggleDelete}
                  >
                    Cancel
                  </Button>
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };
  return (
    <Fragment>
      <Modal isOpen={paymentmodelvisible} toggle={toggle}>
        <ModalBody>
          <Row className="mb-4">
            <Colxx xxs="12">
              <div className="text-center">
                <h6>Add {label} Stripe Integration</h6>
                <Separator className="mb-3" />
                <Form autoComplete="off">
                  <Input
                    type="text"
                    name="integrationName"
                    onChange={handleNameChange}
                    placeholder="Integration Name"
                  />
                <FormGroup className="mt-3">
                    <div className='integration-property text-start'>
                      <div className='row' style={{textAlign:'left'}}>
                        {allProperties.map((p, index) => {
                          return (
                            <div className='col-md-6'>
                              <CustomInput
                                key={p.id}
                                type="radio"
                                id={index}
                                label={p.name}
                                value={p.id}
                                onChange={() => {
                                  handleCheckChange(p.id);
                                }}
                                checked={
                                  inputData.Properties === p.id ? true : false
                                }
                              />
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </FormGroup>
                </Form>

                <ButtonGroup className="mb-2" style={{ marginTop: '20px' }}>
                  <Button
                    color="primary"
                    size="xs"
                    onClick={() => {
                      //console.log(selectedproperty);
                      if (selectedproperty !== '') {
                        handlePayment();
                      } else {
                        toggle();
                        setInputData({ ...inputData, Properties: 0 });
                      }
                    }}
                  >
                    Create New {label} Stripe Integration
                  </Button>

                  <Button size="xs" color="dark" outline onClick={toggle}>
                    Cancel
                  </Button>
                </ButtonGroup>
              </div>
            </Colxx>
          </Row>
        </ModalBody>
      </Modal>
      {generateDeleteButton()}
    </Fragment>
  );
}
